module.exports = __webpack_public_path__ + "img/jwgl-kbbd-lstk.07eda510.png";